var LocationCartStateService = (function () {
    function LocationCartStateService($location) {
        this.$location = $location;
    }
    LocationCartStateService.prototype.get = function () {
        var locationValue = this.$location.search().cart || '';
        var value = locationValue.split(';').map(function (x) {
            return x.split(',').filter(function (y) { return y !== ''; });
        });
        return value;
    };
    LocationCartStateService.prototype.set = function (groups) {
        var locationValue = groups.map(function (x) { return x.join(','); }).join(';');
        this.$location.search('cart', locationValue || null);
        this.$location.replace();
    };
    LocationCartStateService.$inject = ['$location'];
    return LocationCartStateService;
}());
export { LocationCartStateService };
